import { apiRequest } from "../util/apiUtils";

export const eventList = async (params) => {
  try {
    const res = await apiRequest("get", `event/list`, {
      queries: params,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eventDetails = async (params) => {
  try {
    const res = await apiRequest("get", `event/detail/${params?.id}`, {
      queries: {
        ...(params?.type && { type: params?.type }),
        ...(params?.password && { password: params?.password }),
      },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eventAddEdit = async (payload) => {
  try {
    const contentType = payload?.contentType || "multipart/form-data";
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `event/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      contentType
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const createEventByAi = async (payload) => {
  try {
    const contentType = payload?.contentType || "multipart/form-data";
    const res = await apiRequest(
      "post",
      `openai/event/add`,
      {
        body: payload,
      },
      contentType
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eventDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `event/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eventStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `event/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eventOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `event/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const accountCheck = async (params) => {
  try {
    const res = await apiRequest(
      "get",
      `payment-gateway/account/status/check`,
      {
        queries: params,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const stripeReconnect = async (payload) => {
  try {
    const res = await apiRequest("post", `stripe/account/reconnect`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const imageDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `/event/delete/image`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eventCountList = async (params) => {
  try {
    const res = await apiRequest("get", `organization/event/dashboard`, {
      queries: params,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const countList = async (params) => {
  try {
    const res = await apiRequest("get", `organization/reporting/dashboard`, {
      queries: params,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};
